<div class="create-new-user" role="group" aria-label="Choose account type">
    <div class="create-new-user__shell">
        <div class="create-new-user__grid">
            @for (userRole of userRoles; track $index) {
                <button
                    type="button"
                    class="create-new-user__card custom-shadow-lg"
                    [class.create-new-user__card--dealer]="userRole.id === 'dealer'"
                    (click)="onUserRoleSelected(userRole)"
                    [attr.aria-label]="'Select ' + userRole.label + ' account'">
                    <span class="create-new-user__card-inner">
                        <span class="create-new-user__icon-wrap">
                            <svg
                                width="44"
                                height="44"
                                class="create-new-user__card-icon"
                                aria-hidden="true">
                                <use
                                    [attr.href]="
                                        'assets/icons/icons-sprite.svg#' + userRole.iconKey
                                    "></use>
                            </svg>
                        </span>
                        <span class="create-new-user__card-body">
                            <span class="create-new-user__card-label">{{ userRole.label }}</span>
                            <span class="create-new-user__card-desc">{{
                                userRole.description
                            }}</span>
                        </span>
                        <span class="create-new-user__card-cta" aria-hidden="true">
                            <span class="create-new-user__card-cta-pill">
                                <span class="create-new-user__card-cta-text">Continue</span>
                                <svg
                                    class="create-new-user__card-cta-arrow"
                                    viewBox="0 0 20 20"
                                    aria-hidden="true">
                                    <path
                                        fill="currentColor"
                                        d="M11.293 3.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L15.586 11H3a1 1 0 1 1 0-2h12.586l-4.293-4.293a1 1 0 0 1 0-1.414z" />
                                </svg>
                            </span>
                        </span>
                    </span>
                </button>
            }
        </div>
    </div>
</div>
